/* eslint-disable */

import { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { motion } from "framer-motion";

const RaindropCarouselDots = ({
  currentIndex = 0,
  handleNext = () => {},
  showDots = true,
  components = [1, 2, 3],
}) => {
  if (components.length < 2) {
    showDots = false;
  }
  return (
    <div
      className={"flex flex-row gap-2 w-full justify-center p-1"}
      style={{ opacity: showDots ? 1 : 0 }}
      onClick={() => handleNext()}
    >
      {components.map((_, index) => {
        return (
          <motion.div
            key={`carousel-dot-${index}`}
            className={"bg-white rounded-full h-1 w-1"}
            animate={{ opacity: index === currentIndex ? 0.8 : 0.5 }}
          ></motion.div>
        );
      })}
    </div>
  );
};

const RaindropCarousel = ({
  components,
  showDots = true,
  currentIndex,
  setCurrentIndex,
  pixelWidth = 250,
  pixelHeight = 250,
}) => {
  const [internalCurrentIndex, setInternalCurrentIndex] = useState(0);

  if (currentIndex === undefined) {
    currentIndex = internalCurrentIndex;
  }

  if (setCurrentIndex === undefined) {
    setCurrentIndex = setInternalCurrentIndex;
  }

  if (components === undefined || components.length === 0) {
    components = [
      <div
        className="flex flex-col justify-center items-center bg-color-dark-background-tertiary rounded-lg text-color-text-secondary"
        style={{ width: pixelWidth, height: pixelHeight }}
      >
        Default image
      </div>,
      <div
        className="flex flex-col justify-center items-center bg-color-dark-background-tertiary rounded-lg text-color-text-secondary"
        style={{ width: pixelWidth, height: pixelHeight }}
      >
        Default image
      </div>,
    ];
  }

  const handleNext = () => {
    const newIndex = Math.min(currentIndex + 1, components.length - 1);
    setCurrentIndex(newIndex);
  };

  const handlePrevious = () => {
    const newIndex = Math.max(currentIndex - 1, 0);
    setCurrentIndex(newIndex);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleNext(),
    onSwipedRight: () => handlePrevious(),
    trackMouse: true,
  });

  const xOffset = -currentIndex * pixelWidth;

  return (
    <div
      className={"flex flex-col h-fit w-full gap-2 items-center "}
      {...handlers}
    >
      <div style={{ width: pixelWidth, height: pixelHeight }}>
        <motion.div
          id={"carousel-inner"}
          className={"flex flex-row "}
          style={{
            x: xOffset,
          }}
          drag={"x"}
          dragConstraints={{ left: xOffset, right: 0 }}
          animate={{ x: xOffset }}
        >
          {components.map((component, index) => (
            <motion.div
              key={`carousel-component-${index}`}
              initial={{ opacity: index === currentIndex ? 1 : 0 }}
              animate={{ opacity: index === currentIndex ? 1 : 0 }}
            >
              <div
                className="pointer-events-none "
                style={{ width: pixelWidth, height: pixelHeight }}
              >
                {component}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <RaindropCarouselDots
        components={components}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        handleNext={handleNext}
        showDots={showDots}
      />
    </div>
  );
};

export default RaindropCarousel;
